export const ExperienceName = {
	LOAD_PANEL: 'aiMateLoadPanel',
	LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
	LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
	FETCH_CHAT: 'aiMateFetchChat',
	FETCH_AGENTS: 'aiMateFetchAgents',
	FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
	FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
	FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
	FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
	FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
	FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
	FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
	FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
	CREATE_AGENT: 'aiMateCreateAgent',
	UPDATE_AGENT: 'aiMateUpdateAgent',
	DELETE_AGENT: 'aiMateDeleteAgent',
	HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
	FAVOURITE_AGENT: 'aiMateFavouriteAgent',
	UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
	CLEAR_CHAT: 'aiMateClearChat',
	SEND_MESSAGE: 'aiMateSendMessage',
	SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
	SEND_DR_MESSAGE: 'aiMateSendDRMessage',
	SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
	SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
	ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
	GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
	GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
	UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
	CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
	PUBSUB_LISTENER: 'aiMatePubSubListener',
	FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
	RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
	MESSAGE_RENDERER: 'aiMateMessageRenderer',
	FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
	FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
	GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
	FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
	FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
	FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
	CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
	GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
	AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
	PREVIEW_CONTENT: 'aiMatePreviewContent',
	PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
	FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
	SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
	GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
	UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
	VALIDATE_FILES: 'aiMateValidateFiles',
	GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
	AIFC_MESSAGE: 'aiMateAifcMessage',
	AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
	AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
	AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
	AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
	AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
	AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
	CSM_WIDGET_RENDER: 'csmWidgetRender',
	CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
	CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
	CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
	CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
	CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
	CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
	GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
	SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
	/**
	 * If you are updating this, please do not forget to register this value in DataPortal 'attributes' tab - as the possible values for `task`. Otherwise the event will be dropped.
	 * See the guide in https://hello.atlassian.net/wiki/spaces/AA6/pages/3961393753/HOWTO+Create+FE+Reliability+SLO+using+experience+tracker
	 */
} as const satisfies {
	[key: string]: `aiMate${string}` | `csm${string}`;
};
export type ExperienceNameType = (typeof ExperienceName)[keyof typeof ExperienceName];
export enum ExperienceNamePostfix {
	MINI_MODAL = 'miniModal',
}
type SendMessageExperienceNameParams = {
	deepResearchEnabled?: boolean;
	thinkDeeperEnabled?: boolean;
	isCustomRovoAgent?: boolean;
};
export const sendMessageExperienceName = ({
	deepResearchEnabled,
	thinkDeeperEnabled,
	isCustomRovoAgent,
}: SendMessageExperienceNameParams) => {
	if (isCustomRovoAgent) {
		return ExperienceName.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
	}

	if (deepResearchEnabled) {
		return ExperienceName.SEND_DR_MESSAGE;
	}
	if (thinkDeeperEnabled) {
		return ExperienceName.SEND_TD_MESSAGE;
	}

	return ExperienceName.SEND_MESSAGE;
};

export const AIFC_EXPERIENCES_TO_FAIL = [
	ExperienceName.AIFC_GENERATE_CONTENT,
	ExperienceName.AIFC_GENERATE_CONTENT_IN_CHAT,
	ExperienceName.AIFC_UPDATE_CONTENT,
	ExperienceName.AIFC_FINALIZE_CONTENT,
	ExperienceName.AIFC_LOAD_STAGING_AREA_MODAL,
];

export const AIFC_EXPERIENCES_TO_ABORT = [
	// Experiences with timeouts must be listed first:
	ExperienceName.AIFC_INITIAL_DATA_RECEIVED, // AIFC_INITIAL_DATA_RECEIVED must be before AIFC_ALL_DATA_HANDLED, as if AIFC_INITIAL_DATA_RECEIVED aborted but times out, it should fail AIFC_GENERATE_CONTENT

	// Experiences without timeouts:
	ExperienceName.AIFC_ALL_DATA_HANDLED,
	ExperienceName.PREVIEW_CONTENT,
	...AIFC_EXPERIENCES_TO_FAIL,
];
